/**
 * Configuration de la navigation principale
 * Définit tous les items du sidebar avec leurs icônes et permissions
 */

export const navigationItems = [
  {
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'pi pi-th-large',
  },
  {
    name: 'Rendez-vous',
    to: '/rdv',
    icon: 'pi pi-calendar',
  },
  {
    name: 'Acquéreurs',
    to: '/properties/buyers',
    icon: 'pi pi-user',
    items: [
      {
        name: 'En mandat',
        to: '/properties/buyers?buyerType=mandat',
      },
      {
        name: 'En prospection',
        to: '/properties/buyers?buyerType=prospection',
      },
    ],
  },
  {
    name: 'Vendeurs',
    to: '/properties/sellers',
    icon: 'pi pi-user',
    items: [
      {
        name: 'En mandat',
        to: '/properties/sellers?sellerType=mandat',
      },
      {
        name: 'En prospection',
        to: '/properties/sellers?sellerType=prospection',
      },
    ],
  },
  {
    name: 'Suivi',
    to: '/suivi',
    icon: 'pi pi-chart-bar',
    items: [
      {
        name: 'Compromis',
        to: '/suivi/compromis',
      },
      {
        name: 'Commission',
        to: '/agents/commissions',
        icon: 'pi pi-euro',
      },
    ],
  },
  {
    name: 'Contacts',
    to: '/contacts',
    icon: 'pi pi-address-book',
  },
  {
    // Agent : ses secteurs. Admin : secteurs des agents + codes postaux couverts.
    name: 'Secteurs',
    to: '/secteurs',
    icon: 'pi pi-map',
  },
  {
    name: 'Biens & Scraping',
    isSectionTitle: true,
  },
  {
    name: 'Biens',
    to: '/properties',
    icon: 'pi pi-home',
  },
  {
    name: 'Ajouter un bien',
    to: '/properties/add',
    icon: 'pi pi-plus-circle',
  },
  {
    name: 'Scraping',
    to: '/properties/prospection',
    icon: 'pi pi-search',
  },
  {
    name: 'Estimations',
    to: '/properties/estimations',
    icon: 'pi pi-calculator',
  },
  {
    name: 'Études',
    to: '/studies',
    icon: 'pi pi-book',
  },
  {
    name: 'Gestion des agences',
    isSectionTitle: true,
    adminOnly: true,
  },
  {
    name: 'Agences',
    to: '/agences',
    icon: 'pi pi-building',
    adminOnly: true,
  },
  {
    name: 'Paramètres',
    to: '/parametres',
    icon: 'pi pi-cog',
    items: [
      {
        name: 'Disponibilités',
        icon: 'pi pi-calendar-clock',
        items: [
          {
            name: 'En semaine',
            to: '/availability/weekly',
          },
          {
            name: 'Vacances',
            to: '/availability/vacation',
          },
        ],
      },
    ],
  },
  {
    name: 'Agents',
    to: '/agents',
    icon: 'pi pi-users',
    adminOnly: true,
  },
  {
    name: 'Gestion des notaires',
    isSectionTitle: true,
    adminOnly: true,
  },
  {
    name: 'Études notariales',
    to: '/etudes-notariales',
    icon: 'pi pi-building-columns',
    adminOnly: true,
  },
  {
    name: 'Notaires',
    to: '/notaires',
    icon: 'pi pi-briefcase',
    adminOnly: true,
  },
  {
    name: 'Comptes',
    to: '/accounts',
    icon: 'pi pi-id-card',
    adminOnly: true,
  },
  {
    name: 'Parrainage',
    to: '/sponsorship',
    icon: 'pi pi-share-alt',
  },
  {
    name: 'Statistiques',
    to: '/statistics',
    icon: 'pi pi-chart-line',
    adminOnly: true,
  },
]

export const notaryNavigationItems = [
  {
    name: 'Dashboard',
    to: '/notaire',
    icon: 'pi pi-th-large',
  },
  {
    name: 'Rendez-vous',
    to: '/notaire/rdv',
    icon: 'pi pi-calendar',
  },
  {
    name: 'Biens',
    to: '/notaire/biens',
    icon: 'pi pi-home',
  },
  {
    name: 'Mon étude',
    to: '/notaire/etude',
    icon: 'pi pi-building',
  },
]
